declare global {
  interface Window {
    env: any;
  }
}

type EnvType = {
  REACT_APP_BACKEND_URL: string;
  REACT_APP_ENV: string | undefined;
  REACT_APP_KEYCLOAK_URL: string;
  [key: string]: string | undefined;
};

const runtimeEnv = window.env ?? {};
const buildEnv = process.env;
const mergedEnv = process.env.NODE_ENV === "development" ? { ...runtimeEnv, ...buildEnv } : { ...buildEnv, ...runtimeEnv };

export const env: EnvType = {
  REACT_APP_BACKEND_URL: "http://localhost:8081",
  REACT_APP_KEYCLOAK_URL: "http://localhost:8080",
  ...mergedEnv,
  ...(!("REACT_APP_ENV" in mergedEnv) && {
    REACT_APP_ENV: process.env.NODE_ENV,
  }),
};
